export default "__VITE_ASSET__CkLspwLY__"